import styled from 'styled-components'

const MapStyle = styled.div`
	--customFontSize: 32px;
	--titleMarginBottom: var(--sp10x);
	--pointMarginTop: var(--sp4x);
	--pointNumberMinWidth: var(--sp6x);
	--pointNumberMarginRight: var(--sp4x);

	.title {
		margin-bottom: var(--titleMarginBottom);
	}

	.points-container {
		.point-wrap {
			display: flex;
			margin-top: var(--pointMarginTop);
			font-size: var(--customFontSize);

			&:first-child {
				margin-top: unset;
			}
		}

		.point-number {
			font-size: var(--customFontSize);
			min-width: var(--pointNumberMinWidth);
			margin-right: var(--pointNumberMarginRight);
		}

		.point {
			font-size: var(--customFontSize);
		}
	}

	.map-image {
		padding-top: 100%;

		img {
			object-fit: contain;
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--titleMarginBottom: var(--sp8x);
		--pointMarginTop: var(--sp3x);
		--customFontSize: 24px;
		--pointNumberMinWidth: var(--sp5x);
		--pointNumberMarginRight: var(--sp3x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--titleMarginBottom: var(--sp7x);
		--pointMarginTop: var(--sp2-5x);
		--customFontSize: 20px;
		--pointNumberMinWidth: var(--sp4x);
		--pointNumberMarginRight: var(--sp3x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--titleMarginBottom: var(--sp6x);
		--pointMarginTop: var(--sp2-5x);
		--customFontSize: 20px;
		--pointNumberMinWidth: var(--sp4x);
		--pointNumberMarginRight: var(--sp3x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--titleMarginBottom: var(--sp5x);
		--pointMarginTop: var(--sp2-5x);
		--customFontSize: 20px;
		--pointNumberMinWidth: var(--sp4x);
		--pointNumberMarginRight: var(--sp3x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--titleMarginBottom: var(--sp4x);
		--pointMarginTop: var(--sp2x);
		--customFontSize: 20px;
		--pointNumberMinWidth: var(--sp4x);
		--pointNumberMarginRight: var(--sp2x);

		.offset {
			display: none;
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--titleMarginBottom: var(--sp4x);
		--pointMarginTop: var(--sp2x);
		--customFontSize: 20px;
		--pointNumberMinWidth: var(--sp4x);
		--pointNumberMarginRight: var(--sp3x);
		--pointNumberMarginRight: var(--sp2x);

		.offset {
			display: none;
		}

		.map-image {
			margin-top: var(--sp6x);
		}
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--titleMarginBottom: var(--sp4x);
		--pointMarginTop: var(--sp2-5x);
		--customFontSize: 20px;
		--pointNumberMinWidth: var(--sp4x);
		--pointNumberMarginRight: var(--sp1-5x);

		.offset {
			display: none;
		}

		.map-image {
			margin-top: var(--sp5x);
		}
	}
`

export default MapStyle
